import React from "react";
import Layout from "../components/layout/index";
import constants from "../constants";

const Profile = () => {

  const title = constants.modules.profile;

  return (
    <Layout title={title}>
      <div className="surface-0 text-700 text-center m-3">Profile</div>
    </Layout>
  );

};

export default Profile;
